import { useTranslation } from 'react-i18next';

import { MessageType } from 'types/api/message.type';

import { InfoModal } from 'components/InfoModal';

import { useChat } from './Chat.hooks';
import * as S from './Chat.styles';

type ChatProps = {
  customerId: string;
  customerCode: string | null;
  customerName: string;
  messages?: MessageType[];
};

const defaultProps: Partial<ChatProps> = {
  messages: undefined,
};

export function Chat(props: ChatProps): React.ReactElement {
  const { customerId, customerCode, customerName, messages } = {
    ...defaultProps,
    ...props,
  };
  const { t } = useTranslation();

  const {
    isVisibleSet,
    register,
    messageGroupMapped,
    onEnterPress,
    ref,
    message,
    sendMessage,
    isModalVisible,
    isModalVisibleSet,
    messageSent,
    isRestoreRequest,
    isRestoreRequestSet,
    setIsSent,
    messagesSet,
  } = useChat(customerId, customerCode, messages);

  return (
    <S.Container>
      {isModalVisible && isRestoreRequest ? (
        <InfoModal
          title={t('chat.activationRequest')}
          info={t('chat.reactivationConfirm')}
          actionText="Yes"
          onAction={() => {
            isVisibleSet(false);
            isModalVisibleSet(false);
            isRestoreRequestSet(false);
          }}
          onClose={() => isModalVisibleSet(false)}
        />
      ) : null}
      <S.Inner>
        <S.Header>
          {customerName ? <S.Name color="white">{customerName}</S.Name> : null}

          <S.CloseButton
            iconLeft="FiXCircle"
            motive="white"
            onClick={() => {
              if (!messageSent && isRestoreRequest) {
                isModalVisibleSet(true);
              } else {
                isVisibleSet(false);
                setIsSent(false);
                messagesSet([]);
              }
            }}
          />
        </S.Header>

        <S.Messages>
          {messageGroupMapped}

          <div ref={ref} />
        </S.Messages>

        <S.TextContent>
          <S.Area onKeyDown={onEnterPress} register={register} name="message" />

          {message && message.length > 0 ? (
            <S.SendButton motive="send" iconLeft="FiArrowUp" onClick={() => sendMessage()} />
          ) : null}
        </S.TextContent>
      </S.Inner>
    </S.Container>
  );
}
